module.exports = __webpack_public_path__ + "media/images/Confused-4fb52b6c.svg";